<template>
	<highcharts :options="reformatOptions"></highcharts>
</template>
<script>
import ChartHelper from 'Mixins/ChartHelper'
export default {
	props: {
		options: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	mixins: [ChartHelper],
	data() {
		return {}
	},
	computed: {
		reformatOptions() {
			let roast = this.roast(this.options)
			let type = 'column'
			if ('barType' in this.options) {
				if (this.options.barType == 'horizontal') {
					type = 'bar'
				} else if (this.options.barType == 'vertical') {
					type = 'column'
				}
			}
			let chartOptions = {
				...roast,
				chart: {
					type,
					inverted: false,
					polar: false
				}
			}
			return chartOptions
		}
	}
}
</script>
